import { S } from "../Squaremap.js";

class Pin {
    /** @type {boolean} */
    pinned;
    /** @type {HTMLButtonElement} */
    element;

    /**
     * @param {boolean} def
     */
    constructor(def) {
        this.pinned = def;

        this.element = S.createElement("button", "pin", this);
        this.element.type = "button";

        this.element.onclick = () => this.toggle();

        this.pin(this.pinned);
    }
    toggle() {
        this.pin(!this.pinned);
    }
    pin(pin) {
        this.pinned = pin;
        this.element.className = pin ? "pinned" : "unpinned";
        this.element.textContent = pin ? "Vastgezet" : "Menu vastzetten";
        this.element.setAttribute("aria-pressed", String(pin));
        this.element.title = pin ? "Menu automatisch laten sluiten" : "Menu openhouden";
    }
}

export { Pin };
